export type ErrorKind =
  | 'camera_denied'
  | 'mediapipe_failed'
  | 'webgl_unavailable'
  | 'low_fps'
  | 'none';

export class Intro {
  private root: HTMLElement;
  private card: HTMLDivElement | null = null;

  constructor(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.id = 'intro-root';
    this.root.style.cssText = 'position:absolute;inset:0;z-index:50;display:flex;align-items:center;justify-content:center;';
    parent.appendChild(this.root);
  }

  show(
    title: string,
    message: string,
    primaryAction: { label: string; onClick: () => void } | null = null,
    secondaryAction: { label: string; onClick: () => void } | null = null
  ): void {
    this.hide();
    const card = document.createElement('div');
    card.className = 'intro-card';
    const h1 = document.createElement('h1');
    h1.textContent = title;
    const p = document.createElement('p');
    p.textContent = message;
    card.appendChild(h1);
    card.appendChild(p);
    if (primaryAction || secondaryAction) {
      const row = document.createElement('div');
      row.style.cssText = 'display:flex;gap:12px;justify-content:center;';
      if (primaryAction) {
        const btn = document.createElement('button');
        btn.className = 'btn';
        btn.textContent = primaryAction.label;
        btn.addEventListener('click', primaryAction.onClick);
        row.appendChild(btn);
      }
      if (secondaryAction) {
        const btn = document.createElement('button');
        btn.className = 'btn btn-secondary';
        btn.textContent = secondaryAction.label;
        btn.addEventListener('click', secondaryAction.onClick);
        row.appendChild(btn);
      }
      card.appendChild(row);
    }
    this.root.appendChild(card);
    this.card = card;
  }

  hide(): void {
    if (this.card) {
      this.card.remove();
      this.card = null;
    }
  }
}
